import type { HTMLAttributes } from 'react';

import { cn } from '../../lib/cn.ts';

export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('rounded-xl border border-border bg-surface p-5 shadow-sm sm:p-6', className)}
      {...props}
    />
  );
}
